import api from './api';

// Kept out of lib/api.js and lib/api/*.js deliberately, same posture as
// lib/adminReceiptPaidTraceApi.js: diagnostics.js and DiagnosticsPage.jsx
// are edited concurrently by other sessions, and this is the only call
// site this card needs. Reuses api's shared axios instance (baseURL, auth
// interceptor) unchanged.
//
// Single out-of-band action (202 + job id, JobStore-backed), same shape as
// adminReceiptPaidTraceApi's funnelSummary trio -- one operation key
// ("autopsy"), so a second click while a run is in flight returns the
// in-progress job instead of racing it.
export const adminReceiptPaidNoCandidateAutopsyAPI = {
  start: () => api.post('/admin/diagnostics/receipt-paid-no-candidate-autopsy/start'),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/receipt-paid-no-candidate-autopsy/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/receipt-paid-no-candidate-autopsy/job-latest'),
  // Phase 0 vendor-census (Prompt: "vendor-census ON the card"): the route
  // itself predates this client method (URL-only, operator-typed against
  // prod from the browser) -- this is the first frontend consumer.
  vendorCensus: (vendor) => api.get(
    '/admin/diagnostics/receipt-paid-no-candidate-autopsy/vendor-census', { params: { vendor } },
  ),
};
